import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Select } from "@rmwc/select";
import SummaryTotal from "./SummaryTotal";
import {
  getComparisionData,
  handleShowComparePriceModal,
  prepareNewBuilding,
  setManufacturer,
  handleSummaryComapreModal
} from "../../../action";

import Higher from '../../../assets/images/comparePrice/higher_non.svg';
import Average from '../../../assets/images/comparePrice/average_non.svg';
import Lowest from '../../../assets/images/comparePrice/lowest_non.svg';
import InfoIcon from '../../../assets/images/comparePrice/info-icon.svg';
import HelpIcon from '../../../assets/images/comparePrice/help-icon.svg';
import NoOfferIcon from '../../../assets/images/comparePrice/no-offer-icon.svg';
import BuildingSummaryIcon from '../../../assets/images/comparePrice/building-summary.svg';
import Summary from "../Summary/Summary";

const ComparePriceNotLoggedIn = ({
  handleStartAnimation,
  setLoading,
  loading,
  selectedManufactures = [],
  allManufacturers,
  handleTabSelect,
  isShowComparePriceModal,
  isFromSummary,
  custom,
  showDefaultOfferonly,
  ...props
}) => {
  const state = useSelector((state) => state.reducer);
  const selectedManufacturer = state.selectedManufacturer;
  const dispatch = useDispatch();

  const [selectedSpecial, setSelectedSpecial] = useState(-1);
  const [selectedPriceDetail, setSelectedPriceDetail] = useState(-1);
  const [showPriceDetail, setShowPriceDetail] = useState(false);
  const [showComment, setShowComment] = useState(false);
  const [showInfo, setShowInfo] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [compareLoading, setCompareLoading] = useState(false);
  const isLoggedIn = state.const_var.loginSession;
  const isGlobalLoading = state.const_var.showProcessLoaderchkEdit;
  useEffect(() => {
    if (!isLoggedIn && allManufacturers?.length > 0 && isShowComparePriceModal) {
      dispatch(setManufacturer(0));
      if(!showDefaultOfferonly){
        allManufacturers.forEach((item, idx) => {
          if (item.id) {
            dispatch(getComparisionData(item.id, `_${idx + 1}`));
          }
        });
        setIsLoading(false);
        setCompareLoading(true);
      }
    }
  }, [allManufacturers]);

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [])

  const priceDetailRef = useRef(null);
  const handleOutsideClick = (event) => {
      if (priceDetailRef.current && !priceDetailRef.current.contains(event.target)) {
          setShowPriceDetail(false);
          setSelectedPriceDetail(-1)
      }
  }

  useEffect(() => {
    if (state.const_var.comparisionLoadermfg2 == false) {
      setTimeout(() => {
        setCompareLoading(false)
        clearTimeout()
      }, 3000)
    }
  }, [
    state.const_var.comparisionLoadermfg2,
  ]);

  const comparisionLoadermfg1 = state.const_var.comparisionLoadermfg1;
  const comparisionLoadermfg2 = state.const_var.comparisionLoadermfg2;
  // if (isLoading || isGlobalLoading) return null;
  if (!showDefaultOfferonly && (isLoading || isGlobalLoading)) return null;

  let firstManufactureCompareData =
    state.const_var.ComparisionDataArray[state.params.m_s_n_1] != undefined &&
    state.const_var.ComparisionDataArray[state.params.m_s_n_1].post_data !=
      undefined
      ? state.const_var.ComparisionDataArray[state.params.m_s_n_1].post_data
          .building
      : "";
  let secondManufactureCompareData =
    state.const_var.ComparisionDataArray[state.params.m_s_n_2] != undefined &&
    state.const_var.ComparisionDataArray[state.params.m_s_n_2].post_data !=
      undefined
      ? state.const_var.ComparisionDataArray[state.params.m_s_n_2].post_data
          .building
      : "";

  let grandTotalFirstManu =
    firstManufactureCompareData != undefined &&
    firstManufactureCompareData.BuildingPriceArrarNew != undefined &&
    state.const_var.showComparePrices == true
      ? firstManufactureCompareData.BuildingPriceArrarNew[
          "new_down_payment_total"
        ]
      : 0;

  let grandTotalSecondManu =
    secondManufactureCompareData != undefined &&
    secondManufactureCompareData.BuildingPriceArrarNew != undefined &&
    state.const_var.showComparePrices == true
      ? secondManufactureCompareData.BuildingPriceArrarNew[
          "new_down_payment_total"
        ]
      : 0;

  let grandTotalMainManu =
    state.const_var != undefined &&
    state.const_var.BuildingPriceArrar != undefined
      ? state.const_var.BuildingPriceArrar["new_down_payment_total"].toFixed(2)
      : 0;
  //let grandTotalMainManu = (state.const_var != undefined && state.const_var.BuildingPriceArrar != undefined && state.const_var.BuildingPriceArrar['new_down_payment_total'] != undefined) ? (state.const_var.BuildingPriceArrar['new_down_payment_total'] + state.const_var.BuildingPriceArrar['custom_down_payment_total'] + state.const_var.BuildingPriceArrar["grvy_value"]).toFixed(2) : 0;

  const manufacturerList = [
    {
      manufacturer: "Manufacturer1",
      tags: [
        "Lowest Price",
        "Experienced",
        "Quick Delivery",
        "Positive Customer Reviews",
        "Great Crews",
        "Competitive Price",
        "Best Reviewed",
        "Best Reviewed",
        "Experienced",
        "Quick Delivery",
        "Local Favorite",
      ],
      ratings: [
        { title: "Price", value: 5.0 },
        { title: "Components", value: 2.0 },
        { title: "Quality", value: 3.0 },
        { title: "Installation Time", value: 5.0 },
        { title: "Call Support", value: 4.6 },
      ],
      special: "55%",
      specialBuildings: [
        "32x21 Metal Building",
        "34x46 Metal Building",
        "40’ Wide Metal Buildings",
        "46’ Wide Metal Buildings",
      ],
      buildingType_id: 1,
      price: grandTotalMainManu,
      compareManufactureIndex: "0",
      manufactureId: state.params.m_s_n,
    },
    {
      manufacturer: "Manufacturer2",
      tags: [
        "Lowest Price",
        "Experienced",
        "Quick Delivery",
        "Positive Customer Reviews",
        "Great Crews",
        "Competitive Price",
        "Best Reviewed",
        "Best Reviewed",
        "Experienced",
        "Quick Delivery",
        "Local Favorite",
      ],
      ratings: [
        { title: "Price", value: 5.0 },
        { title: "Components", value: 2.0 },
        { title: "Quality", value: 3.0 },
        { title: "Installation Time", value: 5.0 },
        { title: "Call Support", value: 4.6 },
      ],
      special: "55%",
      specialBuildings: [
        "32x21 Metal Building",
        "34x46 Metal Building",
        "40’ Wide Metal Buildings",
        "46’ Wide Metal Buildings",
      ],
      buildingType_id: 1,
      price: grandTotalFirstManu,
      compareManufactureIndex: "_1",
      manufactureId: state.params.m_n_f_1,
    },
    {
      tags: [
        "Quick Delivery",
        "Best Reviewed",
        "NewShop",
        "Positive Customer Reviews",
        "Great Crews",
        "Competitive Price",
      ],
      ratings: [
        { title: "Price", value: 5.0 },
        { title: "Components", value: 4 },
        { title: "Quality", value: 3.9 },
        { title: "Installation Time", value: 5.0 },
        { title: "Call Support", value: 5.0 },
      ],
      special: "20%",
      specialBuildings: [
        "32x21 Metal Building",
        "34x46 Metal Building",
        "40’ Wide Metal Buildings",
        "46’ Wide Metal Buildings",
      ],
      buildingType_id: 1,
      price: grandTotalSecondManu,
      compareManufactureIndex: "_2",
      manufactureId: state.params.m_n_f_2,
    },
  ];

  // let MFGData = [];
  // if(state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n]!=undefined && state.const_var.user_type_for_comparision!='')
  // {
  //     MFGData = state.const_var.stateManufacturerAcordingAPI[state.params.p_s_n].filter(data=>data.id!=state.params.m_s_n);
  // }
  // let mainManufactureData =
  //   state.const_var.post_data != undefined &&
  //   state.const_var.post_data?.building;

  // const selectManufacturer = (selectedId, selectedIndex) => {
  //   // setCurrentCompareIdx(selectedIndex)
  //   handleStartAnimation(true);
  //   if (selectedIndex == "_1") {
  //     dispatch(setManufacturer(1));
  //     dispatch(getComparisionData(selectedId, "_1"));
  //   }
  //   if (selectedIndex == "_2") {
  //     dispatch(setManufacturer(2));
  //     dispatch(getComparisionData(selectedId, "_2"));
  //   }
  //   handleStartAnimation(true);
  //   // setTimeout(() => {

  //   // }, 2000);
  // };

  const comment =
    "Please be informed that when you opt for this building, certain elements such as the roof style, siding, doors, and windows may need to be modified or removed if they are not available or if their default size is too large to accommodate all the components.";

  const getCompareState = (item, index) => {
    if (state.params.m_n_f_1 == "") {
      return "";
    } 
    else if(state.params.m_n_f_2 == ''){
      if (index === 0) {
        if (
          grandTotalMainManu > grandTotalFirstManu
        ) {
          return "higher";
        } 
        else {
          return "lowest";
        }
      }
      if (index == 1) {
        if (
          grandTotalMainManu < grandTotalFirstManu
        ) {
          return "higher";
        } 
        else {
          return "lowest";
        }
      }
    } else {
      if (index === 0) {
        if (
          grandTotalMainManu >= grandTotalFirstManu &&
          grandTotalMainManu >= grandTotalSecondManu
        ) {
          return "higher";
        } else if (
          grandTotalMainManu > grandTotalFirstManu &&
          grandTotalMainManu < grandTotalSecondManu
        ) {
          return "average";
        } else if (
          grandTotalMainManu < grandTotalFirstManu &&
          grandTotalMainManu > grandTotalSecondManu
        ) {
          return "average";
        } else {
          return "lowest";
        }
      }
      if (index == 1) {
        if (
          grandTotalMainManu <= grandTotalFirstManu &&
          grandTotalFirstManu >= grandTotalSecondManu
        ) {
          return "higher";
        } else if (
          grandTotalMainManu > grandTotalFirstManu &&
          grandTotalFirstManu > grandTotalSecondManu
        ) {
          return "average";
        } else if (
          grandTotalMainManu < grandTotalFirstManu &&
          grandTotalFirstManu < grandTotalSecondManu
        ) {
          return "average";
        } else {
          return "lowest";
        }
      }
      if (index == 2) {
        if (
          grandTotalMainManu <= grandTotalSecondManu &&
          grandTotalFirstManu <= grandTotalSecondManu
        ) {
          return "higher";
        } else if (
          grandTotalMainManu < grandTotalSecondManu &&
          grandTotalFirstManu > grandTotalSecondManu
        ) {
          return "average";
        } else if (
          grandTotalMainManu > grandTotalSecondManu &&
          grandTotalFirstManu < grandTotalSecondManu
        ) {
          return "average";
        } else {
          return "lowest";
        }
      }
    }

    // return grandTotalFirstManu > grandTotalSecondManu ? 'higher' : item.price > 600 ? 'average' : item.price > 900 ? 'lowest' : ''
  };

  const getpriceLevelValue = (value, isCurrent) => {
    if (isCurrent) return "Current Price";
    if (value.toLowerCase()?.includes("higher")) return "Higher Price";
    if (value.toLowerCase()?.includes("average")) return "Average Price";
    if (value.toLowerCase()?.includes("lowest")) return "Lowest Price";
  };

  const LoadingComponent = ({ message }) => (
    <div className={`choose-manufacturer ${compareLoading ? "loading-choose-manufacturer" : ""}`}>
      <div className="manufacturer-loading">
        <div className="spinner-loading">
          <div className="spinner"></div>
          <div className="spinner-value">Loading</div>
        </div>
        <div className="loading-text">
          <h3>Please wait...</h3>
          <span>We're comparing your building</span>
        </div>
      </div>
    </div>
  );

  const handleShowPriceModal=()=>{
    if(isFromSummary){ 
      dispatch(handleSummaryComapreModal());
    }
    else{
       dispatch(handleShowComparePriceModal())
     }
  }

  const onChangeFn =(index)=>{
      if (index == 1) {
        dispatch(
          prepareNewBuilding(state.params.m_s_n_1)
        );
      }
      if (index == 2) {
        dispatch(
          prepareNewBuilding(state.params.m_s_n_2)
        );
      }
      handleTabSelect && handleTabSelect(0)
      // dispatch(handleShowComparePriceModal());
      handleShowPriceModal()
  }

  const compareRows = (item, index) => {
    return(
        <div
          key={index}
          className={`manufacturer-item item-${getCompareState(item, index)}`}
          style={{
            zIndex:
              selectedSpecial === index || selectedPriceDetail === index
                ? 2
                : 1,
          }}
          onClick={(e) => {
            e.preventDefault();
            handleStartAnimation(true);

            dispatch(setManufacturer(index));
          }}
        >
          <div className='item-info'>
            <div className="left-container">
              {item.compareManufactureIndex == "0" && (
                <div
                  className="manufacturer-name"
                  style={{
                    color:
                      selectedManufacturer === index
                        ? "#000000"
                        : "#333333",
                  }}
                >
                  <div className="manufacturer-name">
                    {" "}
                    Offer {index + 1}
                  </div>
                  {
                    index === 0 && <div className='state-badge'>Current</div>
                  }
                </div>
              )}
              {item.compareManufactureIndex == "_1" && (
                <div
                  className="manufacturer-name"
                  style={{
                    color:
                      selectedManufacturer === index
                        ? "#000000"
                        : "#333333",
                  }}
                >
                  <div className="manufacturer-name">
                    {" "}
                    Offer {index + 1}
                  </div>
                </div>
              )}
              {item.compareManufactureIndex == "_2" && (
                <div
                  className="manufacturer-name"
                  style={{
                    color:
                      selectedManufacturer === index
                        ? "#000000"
                        : "#333333",
                  }}
                >
                  <div className="manufacturer-name">
                    {" "}
                    Offer {manufacturerList[1] && manufacturerList[1].price == 0 ? index : index + 1}
                  </div>
                </div>
              )}
            </div>
            <>
              {parseFloat(item.price).toFixed(2) <= 0 ? (
                <div className="right-container">
                  <div className="price-container">
                    <div className="top-section-box">
                      <h6 style={{fontSize:'16px'}}>No Data Available</h6>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="right-container">
                  <div className="price-container">
                    <div className="price-detail">
                      <div>
                        <div
                          className={`price-value ${getCompareState(
                            item,
                            index
                          )}`}
                        >
                          ${parseFloat(item.price).toFixed(2)}
                          {parseFloat(item.price) > 0 &&
                            <i
                              className="icon-info-ico"
                              onClick={() => {
                                setSelectedPriceDetail(index);
                                setShowPriceDetail(true)
                              }}
                            ></i>
                          }
                        </div>
                        <div className="price-label">
                          Due Today (Down Payment)
                        </div>
                      </div>

                      {parseFloat(item.price) > 0 &&
                      <>
                        {showPriceDetail && index === selectedPriceDetail && (
                          <div ref={priceDetailRef} className="price-detail-tooltip">
                            <SummaryTotal item={item} mode='popup'/>
                            <i
                              className="icon-close"
                              onClick={() => {
                                setSelectedPriceDetail(-1);
                                setShowPriceDetail(false);
                              }}
                            ></i>
                          </div>
                        )}
                      </>
                      }
                    </div>
                  </div>
                </div>
              )}
            </>
            {
              (getCompareState(item, index) !== '' && getCompareState(item, index) !== 'default') &&
              <div className={`price-scale ${getCompareState(item, index)}`}>{getCompareState(item, index)} Price </div>
            }
            <div className='header-image-container'>
              {
                getCompareState(item, index) === 'higher' ?
                <img src={process.env.REACT_APP_BASE_URL+Higher} alt='higher-header' />
                :
                (
                  getCompareState(item, index) === 'lowest' ?
                  <img src={process.env.REACT_APP_BASE_URL+Lowest} alt='lowest-header' />
                  :
                  <img src={process.env.REACT_APP_BASE_URL+Average} alt='average-header' />
                )
              }
            </div>
          </div>
          <div className={'detail-wrapper' + (showPriceDetail && index === selectedPriceDetail ? ' tooltip-visible' : '')}>
            {/* <div className='important-info'>
              {index !== 0 && (
                <div>
                  <button
                    className="btn btn-primary pick-building"
                    onClick={() => {
                      if (index == 1) {
                        dispatch(
                          prepareNewBuilding(state.params.m_s_n_1)
                        );
                      }
                      if (index == 2) {
                        dispatch(
                          prepareNewBuilding(state.params.m_s_n_2)
                        );
                      }
                      handleTabSelect && handleTabSelect(0)
                      // dispatch(handleShowComparePriceModal());
                      handleShowPriceModal()
                    }}
                  >
                    PICK THIS BUILDING
                  </button>
                </div>
              )}
            </div> */}
            <SummaryTotal item={item} itemIndex={index} onChangeFn={()=>onChangeFn(index)} showPickThis={true} />
            <div className='summary-detail-container'>
              <div className='building-summary-container'>
                <img src={process.env.REACT_APP_BASE_URL+BuildingSummaryIcon} alt='building summary' />
                <div className='building-summary-title'>Building Summary</div>
              </div>
              <Summary item={item} isFromComapre={true} />
            </div>
          </div>
        </div>
    )
  }

  const twoSection = (state.params.m_n_f_1 == "Select" || state.params.m_n_f_1 == "" || state.params.m_n_f_1 == null) ||
                     (state.params.m_n_f_2 == "Select" || state.params.m_n_f_2 == "" || state.params.m_n_f_2 == null)
                     ? 'two-section-container': ''

  const noDataUI = () => {
    return(
      <div className="manufacturer-item no-offer-item">
        <div className="no-offer-container">
          <div>
            <img src={process.env.REACT_APP_BASE_URL+NoOfferIcon} alt='oops' />
          </div>
          <div className="no-offer-text">
            <div className="title">Oops.. No Offer Available</div>
            <div className="comment"></div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`non-loggedIn-compare-price-wrapper scroll-${selectedPriceDetail} ${twoSection}`}>
      <div className="header-container">
        <div className="compare-heading">
          <div className='header-title'>Compare Price</div>
          <div className="comment-container">
            {showComment ? (
              <>
                {comment + " "}
                <span onClick={() => setShowComment(false)}>read less</span>
              </>
            ) : (
              <>
                {comment.substring(0, 60) + "..."}
                <span onClick={() => setShowComment(true)}>read more</span>
              </>
            )}
          </div>
        </div>
        <div className="building-container">
          <div className="compare-select">
            <div>
              <div className="label">Building Type</div>
              <div className="value">{state.params.building_type_name}</div>
            </div>
          </div>
          <div className="compare-select">
            <div>
              <div className="label">Width</div>
              <Select
                className="disabled opc-1"
                value={state.params.p_w}
                options={state.const_var.buildingWidthArray}
              />
            </div>
            <div>{/* <i className='icon-arrow-down-ico'></i> */}</div>
          </div>
          <div className="compare-select">
            <div>
              <div className="label">Length</div>
              <Select
                className="disabled opc-1"
                value={state.params.p_d}
                options={state.const_var.buildingLengthArray}
              />
            </div>
            <div>{/* <i className='icon-arrow-down-ico'></i> */}</div>
          </div>
          <div className="compare-select">
            <div>
              <div className="label">Height</div>
              <Select
                className="disabled opc-1"
                value={state.params.p_h}
                options={state.const_var.buildingHeightArray}
              />
            </div>
            <div>{/* <i className='icon-arrow-down-ico'></i> */}</div>
          </div>
        </div>
        <div className='help-container'>
            <img src={process.env.REACT_APP_BASE_URL+HelpIcon} alt="help icon" />
            <div className='help-content'>
                Prices are subject to change based on regional permits and certifications following inspection.
            </div>
        </div>
        <button className="close" onClick={custom}>
          <span className="icon-close"></span>
        </button>
      </div>
      <div className="manufacturer-container">
        {manufacturerList.map((item, index) => {
          if (
            item.compareManufactureIndex == "_1" &&
            (state.params.m_n_f_1 == "Select" ||
              state.params.m_n_f_1 == "" ||
              state.params.m_n_f_1 == null)
          ) {
            return null;
          }
          if (
            item.compareManufactureIndex == "_2" &&
            (state.params.m_n_f_2 == "Select" ||
              state.params.m_n_f_2 == "" ||
              state.params.m_n_f_2 == null)
          ) {
            return null;
          }
          const isLoading = comparisionLoadermfg1 && comparisionLoadermfg2
          // if (isLoading && comparisionLoadermfg1 && comparisionLoadermfg2 && index > 1) return <LoadingComponent key={index} />;
          let customIndex = allManufacturers?.length
          return (
            <>
              {
                index == 0
                ?
                <>
                  {compareRows(item,index)}
                  {/* {showDefaultOfferonly && noDataUI()} */}
                </>
                :
                  <>
                    {
                      compareLoading
                      ?
                        index == customIndex && <LoadingComponent key={index}/>
                      :
                      <>
                        {
                          (item.compareManufactureIndex == "_1" || item.compareManufactureIndex == "_2") && item.price == 0  
                          ?
                            <>
                              {
                                  !comparisionLoadermfg1 && !comparisionLoadermfg2 && !isLoading && (item.compareManufactureIndex == "_2" || item.compareManufactureIndex == "_1") && manufacturerList?.length > 1 && manufacturerList[1].price == 0 && item.price == 0
                                  ?
                                  noDataUI()
                                  :
                                  null
                              }
                            </>
                          :
                          compareRows(item,index)
                        }
                     </>
                    }
                  </>
              }
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ComparePriceNotLoggedIn;
